import { render, staticRenderFns } from "./TCarousel.vue?vue&type=template&id=75fb1b95&scoped=true&"
import script from "./TCarousel.vue?vue&type=script&lang=js&"
export * from "./TCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TCarousel.vue?vue&type=style&index=0&id=75fb1b95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fb1b95",
  null
  
)

export default component.exports